export default __webpack_public_path__ + "static/successful-entrepreneur-01f4b7d3e330333fc96575c2d11bc7d2.png";